// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .end-match-comment{} */

/* .end-match-comment__form__element{} */


.end-match-comment_form_elements-container{
    padding: var(--space-x2) calc(var(--space-x3) * 2);
}

.MuiFormControl-root.end-match-comment__form__element__input {
    width: 100%;
}

.end-match-comment__form__actions{
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.end-match-comment_label-area {
    margin: var(--space-and-half) 0px;
}

.end-match-comment_label-area.baloa-table,
.end-match-comment_textarea-label-area.baloa-table{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.end-match-comment_textarea-label-area{
    margin-bottom: var(--space-half);
    margin-top: var(--space);
}
.end-match-comment_form_elements-container_select{
    display: flex;
    flex-direction: column;
    width: 40%;
}

.end-match-comment_form_elements-container_select .input-field-autocomplete label{
    text-transform: math-auto;
    font-weight: var(--font-normal);
    font-size: 14px;
    color: var(--basic-gray-color);
}

.end-match-comment_form_elements-container_select .input-field-autocomplete .MuiInputBase-root{
    border-radius: 8px;
}

/*Input style */
.end-match-comment__form__element__input textarea{
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
    margin-top: var(--space);
    margin-bottom: var(--space-half);
    margin-left: var(--space-and-half);
    margin-right: var(--space);
    height: var(--space-x2);
    /*color: var(--mid-gray-color);*/
}

.end-match-comment__form__element__input textarea::placeholder{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: calc(var(--space) + 1px);
    line-height: calc(var(--space) + var(--space-quarter));
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--basic-gray-color);
}

.end-match-comment__form__element__input div{
    border-radius: calc( var( --space-half ) + 1px );
    padding: 0px !important;
    background: var(--white-color);
    border: 1px solid var(--new-gray-color);
}

.end-match-comment__form__element__input .MuiOutlinedInput-input{
    padding: 0px;   
}

.end-match-comment__form__element__input .MuiOutlinedInput-notchedOutline {
    border-style: none;
}

.league-match-scorer-form__actions__back-btn {
    border: none;
    color: var( --primary-dark-color );
    margin-right: var( --space-and-half );
    text-transform: capitalize;
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-end-match-comment/TournamentEndMatchCommentComponent.styles.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,wCAAwC;;;AAGxC;IACI,kDAAkD;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,gCAAgC;IAChC,kCAAkC;IAClC,0BAA0B;IAC1B,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,sDAAsD;IACtD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,gDAAgD;IAChD,uBAAuB;IACvB,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,qCAAqC;IACrC,0BAA0B;AAC9B","sourcesContent":["/* .end-match-comment{} */\n\n/* .end-match-comment__form__element{} */\n\n\n.end-match-comment_form_elements-container{\n    padding: var(--space-x2) calc(var(--space-x3) * 2);\n}\n\n.MuiFormControl-root.end-match-comment__form__element__input {\n    width: 100%;\n}\n\n.end-match-comment__form__actions{\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.end-match-comment_label-area {\n    margin: var(--space-and-half) 0px;\n}\n\n.end-match-comment_label-area.baloa-table,\n.end-match-comment_textarea-label-area.baloa-table{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.end-match-comment_textarea-label-area{\n    margin-bottom: var(--space-half);\n    margin-top: var(--space);\n}\n.end-match-comment_form_elements-container_select{\n    display: flex;\n    flex-direction: column;\n    width: 40%;\n}\n\n.end-match-comment_form_elements-container_select .input-field-autocomplete label{\n    text-transform: math-auto;\n    font-weight: var(--font-normal);\n    font-size: 14px;\n    color: var(--basic-gray-color);\n}\n\n.end-match-comment_form_elements-container_select .input-field-autocomplete .MuiInputBase-root{\n    border-radius: 8px;\n}\n\n/*Input style */\n.end-match-comment__form__element__input textarea{\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    margin-top: var(--space);\n    margin-bottom: var(--space-half);\n    margin-left: var(--space-and-half);\n    margin-right: var(--space);\n    height: var(--space-x2);\n    /*color: var(--mid-gray-color);*/\n}\n\n.end-match-comment__form__element__input textarea::placeholder{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: calc(var(--space) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter));\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--basic-gray-color);\n}\n\n.end-match-comment__form__element__input div{\n    border-radius: calc( var( --space-half ) + 1px );\n    padding: 0px !important;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-color);\n}\n\n.end-match-comment__form__element__input .MuiOutlinedInput-input{\n    padding: 0px;   \n}\n\n.end-match-comment__form__element__input .MuiOutlinedInput-notchedOutline {\n    border-style: none;\n}\n\n.league-match-scorer-form__actions__back-btn {\n    border: none;\n    color: var( --primary-dark-color );\n    margin-right: var( --space-and-half );\n    text-transform: capitalize;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
